package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.network.substation.EODSubstationData

open class EODNetworkCapability(
    val substationData: (LogicalBusId) -> EODSubstationData
) : NetworkCapability